var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrgent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33643 4.85352C4.19346 6.57539 3.2583 8.54961 3.2583 10.3902C3.2583 12.0437 3.91513 13.6294 5.08431 14.7986C6.25348 15.9678 7.83922 16.6246 9.49268 16.6246C11.1461 16.6246 12.7319 15.9678 13.901 14.7986C15.0702 13.6294 15.7271 12.0437 15.7271 10.3902C15.7271 6.53086 13.0552 3.56211 10.888 1.40234L8.30518 6.82773L5.33643 4.85352Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgent);
export default __webpack_public_path__ + "static/media/urgent.eed0dc5355840db238684879cdbddf16.svg";
export { ForwardRef as ReactComponent };